const hasRichTextMetadata = (metadata) => {
  if (metadata === null || !(metadata?.blocks && metadata?.entityMap)) {
    return false;
  }

  return (Object.keys(metadata)?.length > 0 ||
    Object.keys(metadata?.entityMap)?.length > 0);
}

export { hasRichTextMetadata };
